import React, { ReactText } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import ControlWrapper from './ControlWrapper'
import TimeBlock from './TimeBlock'

function Control({
  value,
  increment,
  decrement,
  onClick,
}: IHourControlProps & IHourControlPropsDispatch) {
  return (
    <ControlWrapper>
      <b>
        <FiChevronUp
          style={{ cursor: 'pointer' }}
          size={24}
          onClick={increment}
        />
      </b>

      <TimeBlock onClick={onClick} style={{ cursor: 'pointer' }}>
        {value}
      </TimeBlock>

      <b>
        <FiChevronDown
          style={{ cursor: 'pointer' }}
          size={24}
          onClick={decrement}
        />
      </b>
    </ControlWrapper>
  )
}

export default Control

export interface IHourControlProps {
  value: number | string | ReactText
}

export interface IHourControlPropsDispatch {
  increment: () => void
  decrement: () => void
  onClick?: () => void
}
